import * as React from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import Container from "@mui/material/Container";
import Header from "../components/Header";
import ManualContent from "../components/help/ManualContent";
import GoBack from "../components/GoBack";

export default function ManualPage({ title = "Manual" }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const route = searchParams.get("route") || "";

  return (
    <Container component="main" maxWidth="md">
      <GoBack onClick={() => navigate(-1)} />
      <Header label={title} />
      <ManualContent route={route} />
    </Container>
  );
}
